import i18n from '@/locales/index'

export const status = {
  0: 0,
  1: 1
}

export const locate73 = {
  7: {
    code: 'door',
    name: i18n.t('Device.DoorState'),
    params: status
  },
  11: {
    code: 'demistingCtrl',
    name: i18n.t('Device.demist'),
    params: status
  },
  12: {
    code: 'lightCtrl',
    name: i18n.t('Device.lamplight'),
    params: status
  },
  13: {
    code: 'fan',
    name: i18n.t('Device.draughtFan'),
    params: status
  },
  14: {
    code: 'defrost',
    name: i18n.t('Device.defrosting'),
    params: status
  },
  15: {
    code: 'compressor',
    name: i18n.t('Device.compressor'),
    params: status
  }
}
export const iceParams = {
  '0073': locate73
}
